import {ClickerGameLayers, GameObjectsTags} from '../../../ClickerGame.constants';
import {ClickerGCSEngine} from '../../../ClickerGame.types';
import {BACKGROUND_STYLE} from '../BackgroundGalaxy.style';
import {GCS_TOKENS} from '@/di/modules/di.gcs.tokens';
import {Container, FillGradient, Graphics} from 'pixi.js';

import {injected} from 'brandi';

import {PixiViewComponent} from '@/gcs/PixiViewComponent';
import {LocationType} from '@/services/ProjectAuthApi/types';

import {IBackgroundGalaxyDataComponent} from './BackgroundGalaxyDataComponent';

export class BackgroundGalaxyViewComponent extends PixiViewComponent<Container> {
  private rootContainer: Container;
  private backgroundGraphic: Graphics;
  private currentLocation: LocationType;

  private dataComponent?: IBackgroundGalaxyDataComponent;

  constructor(private readonly gcsEngine: ClickerGCSEngine) {
    super();
  }

  public onAddToGameObject(): void {
    this.dataComponent = this.gameObject.getComponentByTag<IBackgroundGalaxyDataComponent>(
      GameObjectsTags.BackgroundDataComponent,
    );
  }

  public renderView(): Container {
    this.currentLocation = this.dataComponent?.locationType || LocationType.Location1;

    this.rootContainer = new Container();

    this.backgroundGraphic = this.createBackground();

    this.rootContainer.addChild(this.backgroundGraphic);

    this.rootContainer.zIndex = ClickerGameLayers.BackgroundLayer;

    return this.rootContainer;
  }

  private createBackground(): Graphics {
    const dimensions = this.gcsEngine.renderer.renderer.getFrameDimensions();
    return new Graphics().rect(0, 0, dimensions.width, dimensions.height).fill(this.createLocationGradient());
  }

  // задает основной градиент фона
  private createLocationGradient(): FillGradient {
    const gradientFill = new FillGradient({
      type: 'linear',
      colorStops: [],
    });

    BACKGROUND_STYLE.gradient[this.currentLocation]?.forEach((item) =>
      gradientFill.addColorStop(item.offset, item.color),
    );

    return gradientFill;
  }
}

injected(BackgroundGalaxyViewComponent, GCS_TOKENS.gcsEngine);
